import { useRef } from "react";
import { useTranslation } from "react-i18next";

import { iconList } from "@/lib/helpers/iconList";

import styles from "./FileInput.module.scss";

import { FieldHeader } from "../FieldHeader/FieldHeader";
import { Icon } from "../Icon/Icon";

export interface FileInputProps {
  label: string;
  icon?: keyof typeof iconList;
  files: File[];
  onFileChange: (file: File[]) => void;
  acceptedMimeTypes?: string[];
  multiple?: boolean;
}

export const FileInput = (props: FileInputProps): JSX.Element => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { t } = useTranslation("translation");

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files ?? []);
    if (files.length) {
      props.onFileChange(files);
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <div>
      <FieldHeader label={props.label} iconName={props.icon as string} />
      <div className={styles.file_input_wrapper} onClick={handleClick}>
        <div className={styles.header_wrapper}>
          <span className={styles.placeholder}>
            {t(
              props.files.length
                ? "fileInputClickToSelectAnotherFile"
                : "fileInputClickToUploadFiles",
            )}
          </span>
          <Icon name="upload" size="normal" color="black" />
        </div>
        <input
          ref={fileInputRef}
          multiple={props.multiple}
          type="file"
          className={styles.file_input}
          onChange={handleFileChange}
          accept={props.acceptedMimeTypes?.join(",")}
          style={{ display: "none" }}
        />
      </div>
      {props.files.map((file) => {
        return (
          <p key={file.name} className={styles.filename}>
            {file.name}
          </p>
        );
      })}
    </div>
  );
};
